<template>
  <DialogLayout
    ref="confirmDialog"
    :maxWidth="maxWidth"
    :title="view.title"
    btnAlign="center"
    enableCancel
    :enableClose="false"
    cardContentClass="px-3 pt-8 pb-4"
    @close="_dialogAction"
    :confirmBtnText="view.confirmBtnText"
    :cancelBtnText="view.cancelBtnText"
  >
    <slot class="colorBlack--text">{{ $t(view.description) }}</slot>
    <v-checkbox
      v-if="view.enableShowRemindCheckbox"
      hide-details
      v-model="disableRemind"
      :label="$t('dontShowAgain')"
      color="primary"
      class="colorBlack--text"
    ></v-checkbox>
  </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/layout/DialogLayout.vue'
export default {
  name: 'ConfirmDialog',
  components: {
    DialogLayout,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'message.confirmToDeleteItem',
    },
    maxWidth: {
      type: Number,
      default: 500,
      required: false,
    },
    description: {
      type: String,
      required: false,
      default: 'message.confirmToDeleteItemMsg',
    },
    enableShowRemindCheckbox: {
      type: Boolean,
      required: false,
      default: false,
    },
    confirmBtnText: {
      type: String,
      required: false,
      default: 'confirm',
    },
    cancelBtnText: {
      type: String,
      required: false,
      default: 'cancel',
    },
  },
  data: () => ({
    resolvePromise: undefined,
    disableRemind: false,

    view: {
      title: '',
      description: '',
      enableShowRemindCheckbox: false,
      confirmBtnText: '',
      cancelBtnText: '',
    },
    globalKey: '',
  }),
  methods: {
    show(config = null) {
      // ----- setting
      if (this.$validate.DataValid(config)) {
        this.view.title = config.title || ''
        this.view.description = config.message || ''
        this.view.enableShowRemindCheckbox = config.enableShowRemindCheckbox || false
        this.view.confirmBtnText = config.confirmBtnText || 'confirm'
        this.view.cancelBtnText = config.cancelBtnText || 'cancel'
        this.globalKey = config.key || ''
        
        this.disableRemind = false
        if (this.view.enableShowRemindCheckbox && config.key) {
          const values = this.$store.getters.confirmAlert.remindValue
          if (values[config.key]) {
            this.disableRemind = true
          }
        }

        if (config.isDelete) {
          this.view.title = 'message.confirmToDeleteItem'
          this.view.description = 'message.confirmToDeleteItemMsg'
        }
      } else {
        this.view.title = this.title
        this.view.description = this.description
        this.view.enableShowRemindCheckbox = this.enableShowRemindCheckbox
        this.view.confirmBtnText = this.confirmBtnText
        this.view.cancelBtnText = this.cancelBtnText
        this.globalKey = ''
      }
      // ----- end of setting

      if (!this.disableRemind) {
        this.$refs.confirmDialog.show()
      }
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve

        if (this.disableRemind) {
          this.resolvePromise(true)
        }
      })
    },

    hide() {
      this.$refs.confirmDialog.hide()
      this.resolvePromise = undefined
    },

    _dialogAction(action) {
      if (action === true) {
        if (this.$validate.DataValid(this.globalKey)) {
          this.$store.dispatch('setConfirmAlertRemind', {
            key: this.globalKey,
            disable: this.disableRemind,
          })
        }

        this.resolvePromise(true)
      } else {
        this.disableRemind = false
        this.resolvePromise(false)
      }
    },
  },
}
</script>
